import { render, staticRenderFns } from "./FormSentence.vue?vue&type=template&id=7f4d8bbe&scoped=true&"
import script from "./FormSentence.vue?vue&type=script&lang=js&"
export * from "./FormSentence.vue?vue&type=script&lang=js&"
import style0 from "./FormSentence.vue?vue&type=style&index=0&id=7f4d8bbe&scoped=true&lang=css&"
import style1 from "./FormSentence.vue?vue&type=style&index=1&id=7f4d8bbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4d8bbe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCol,VIcon})
